<template>
    <div class="relative flex h-full w-full items-center justify-center">
        {{ date.day }}
        <calendar-availability-marker
            v-if="hasSession"
            status="available"
            class="absolute bottom-1 left-1.5 !w-[calc(100%-0.75rem)]"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SelectRecurringProgramStartSessionFragmentFragment } from '~/resources/graphql/graphql'
import CalendarAvailabilityMarker from './CalendarAvailabilityMarker.vue'

const props = defineProps<{
    datesToSessions: Map<
        string,
        {
            data: SelectRecurringProgramStartSessionFragmentFragment
            bookingStatusAvailable: boolean
        }[]
    >
    date: {
        year: number
        month: number
        day: number
    }
}>()

const dateString = computed(() => {
    return (
        String(props.date.year).padStart(4, '0') +
        '-' +
        String(props.date.month + 1).padStart(2, '0') +
        '-' +
        String(props.date.day).padStart(2, '0')
    )
})

const hasSession = computed(() => {
    // Preserve the starting-session calendar's existing session-presence rule.
    const sessions = props.datesToSessions.get(dateString.value)
    return sessions !== undefined && sessions.length > 0
})
</script>
